export default __webpack_public_path__ + "static/media/cardio-shadow.8f26c242.svg";